/**
 * created by xcc on 2022/5/10
 * 用户选择弹框
 */

import React, {Component} from 'react';
import {Button, Input, Modal, Table, Pagination, Radio, Divider} from "antd";
import ScrollBars from "react-custom-scrollbars";
import {getAllUserData} from "../actions/newUserManagement";
import $ from "jquery";

const {Search} = Input;

export default class SelectModal extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            page: 1,
            size: 10,
            total: 0,
            keywords: "",
            deptData: [],
            userData: [],
            hideOnSinglePage: true
        }
    }

    componentWillMount() {

    }

    componentDidMount() {
        this.props.onRef(this);
    }

    getDeptUser() {
        let params = {
            start: this.state.page,
            size: this.state.size,
            deptIds: window.top.currentUser.deptIds
        };
        if (this.state.keywords) {
            params.accountOrName = this.state.keywords;
        }
        getAllUserData(params, (res) => {
            let userData = [];
            let total = 0;
            let hideOnSinglePage = true;
            if (res && res.data.length > 0) {
                hideOnSinglePage = false;
                total = res.count;
                userData = res.data;
                userData.forEach(item => {
                    item.checked = this.props.userInfo.length > 0 && this.props.userInfo[0].id === item.id;
                });
            }
            this.setState({
                userData,
                total,
                hideOnSinglePage
            }, () => {
                $('.ant-pagination-options-quick-jumper').find("input").val("");
            });
        });
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            visible: nextProps.visible
        })
    }

    paginationOnChange(page, pageSize) {
        this.state.page = page;
        this.state.size = pageSize;
        this.getDeptUser();
    }

    /**
     * 渲染
     */
    render() {
        const columns = [
            {
                key: 'select',
                align: "center",
                width: 100,
                render: (text, record) => {
                    return (
                        <div><Radio checked={record.checked} onChange={(e) => {
                            record.checked = !record.checked;
                            (this.state.userData.filter(item => item.id !== record.id)).forEach(i => {
                                i.checked = false;
                            })
                            this.setState({});
                        }}/></div>
                    )
                }
            },
            {
                title: '姓名',
                dataIndex: 'name',
                key: 'name',
                ellipsis: true,
            },
            {
                title: '账号',
                dataIndex: 'account',
                key: 'account',
                ellipsis: true,
            }
        ];
        let pagination = {
            onChange: (page, pageSize) => this.paginationOnChange(page, pageSize),
            onShowSizeChange: (page, pageSize) => {
                this.state.hideOnSinglePage = false;
                this.paginationOnChange(page, pageSize)
            },
            defaultCurrent: 1,
            defaultPageSize: 10,
            current: this.state.page,
            pageSize: this.state.size,
            total: this.state.total,
            showQuickJumper: true, //快速跳转至某一页
            showSizeChanger: true,	//是否可以改变 pageSize
            hideOnSinglePage: this.state.hideOnSinglePage
        };
        return (
            <div>
                <Modal
                    title={this.props.modalTitle}
                    visible={this.state.visible}
                    width={800}
                    onCancel={() => {
                        this.props.onCancel()
                    }}
                    className={"selectUserModal"}
                    maskClosable={false}
                    footer={
                        <div style={{textAlign: "center"}}>
                            <Button onClick={() => {
                                this.props.onCancel()
                            }}>取消</Button>
                            <Button type={"primary"} onClick={() => {
                                this.props.onOk(this.state.userData)
                            }}>确定</Button>
                        </div>
                    }
                >
                    <div style={{width: "100%"}}>
                        <Search placeholder={"请输入关键词"} style={{width: 250, marginBottom: 10}}
                                value={this.state.keywords}
                                onChange={(e) => {
                                    this.setState({keywords: e.target.value})
                                }}
                                onSearch={() => {
                                    this.state.page = 1;
                                    this.getDeptUser();
                                }}
                        />
                        <div id={"table"}>
                            <ScrollBars autoHeight autoHide autoHeightMax={420}>
                                <Table columns={columns}
                                       dataSource={this.state.userData}
                                       pagination={false}/>
                            </ScrollBars>
                            <Divider style={{display: !this.state.userData.length ? "none" : "block"}}/>
                            <div style={{float: "right", marginTop: "10px"}}>
                                <Pagination {...pagination}/>
                            </div>
                            <div style={{clear: "both"}}/>
                            <style>{`
                                #table .ant-table-row:nth-child(2n) {
                                    background-color: rgba(245, 248, 252, 1);}
                                    #table .ant-divider-horizontal{margin: 10px 0px 0px 0px;}
                                    #table .ant-table-placeholder{border-bottom: 0;}
                                    .selectUserModal .ant-modal-body{padding: 10px 24px 10px 24px}
                                    `}</style>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}